import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import Perms from 'auth/perms';
import findIndex from 'lodash/findIndex';
import map from 'lodash/map';
import get from 'lodash/get';
import formatDate from 'helpers/formatDate';
import Comments from 'subsys/comments';
import { Checkbox } from 'containers/form';
import Row, { Col } from 'components/row';
import Button, { btnViews } from 'components/button';
import Icon, { iconTypes } from 'components/icon';
import { ModalButton, Header, Content } from 'components/modal';
import Link from 'components/link';

import linksBackOffice from 'src-sites/backoffice/links';
import linksForum from 'src-sites/forum/links';

// import ComplaintsContent from './complaints-content';
// import ComplaintsButtonChecked from './complaints-button-checked';
import NotificationsContent from './notifications-content';
import ComplaintsContentGetOther from './complaints-content-get-other';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';

const classesBemForm = new Bem('modalContentAdmin');
const bemClassesAdminPane = new Bem('adminPanelForum');
const bemClassesPostControl = new Bem('postControlForum');

/**
 * === PostControl Example ===
 * Рендерит блок управления постом для админа
 *
 * = Example =
 * <PostControl
 *   itemId={data.post_id}
 *   data={data.controlData}
 *   onHandleDeletePost={onHandleDeletePost}
 *   onHandleSelect={onHandleSelectPost}
 *   editBtn={this.renderBtnEdit}
 *   selectedPosts={selectedPosts}
 *   onHandleChangeUser={onHandleChangeUser}
 * />
 *
 */

export default class PostControl extends PureComponent {
  static propTypes = {
    className: PropTypes.string,

    // Selected posts by Admin via checkboxes
    selectedPosts: PropTypes.arrayOf(PropTypes.shape({})),

    // Current post id
    itemId: PropTypes.number.isRequired,

    // Current topic id
    topicId: PropTypes.number,
    userPostsCount: PropTypes.number,
    post: PropTypes.string,

    // Method to select a post (for checkbox)
    onHandleSelect: PropTypes.func.isRequired,

    // Method to delete the post
    onHandleDelete: PropTypes.func.isRequired,

    // Method to edit the post
    editBtn: PropTypes.func,

    // Data which is going to be rendered in the component
    data: PropTypes.shape({
      ip: PropTypes.string,
      roles: PropTypes.arrayOf(PropTypes.string),
      posterId: PropTypes.number,
      userNick: PropTypes.string,
    }),
    checkPermission: PropTypes.func,

    // Show complaint other for moderator in admin panel
    complaintAdministration: PropTypes.bool
  };

  closeModalWarning = () => {
    if (this.modalWarning) this.modalWarning.closeModal();
  }

  renderCheckbox() {
    const { itemId, selectedPosts, onHandleSelect } = this.props;
    const selectedIndex = selectedPosts ?
      findIndex(selectedPosts, post => post.id === itemId) : -1;

    return (
      <Checkbox
        {...bemClassesPostControl('checkbox')}
        value={selectedIndex >= 0}
        onChange={checked => onHandleSelect(checked, { id: itemId })}
        disableValidationState
        withIcon
        noPadding
        noLabel
        noError
        white
      />
    );
  }

  renderUserRoles(roles) {
    return map(roles, (role, index) => (
      <div key={index}>
        <span {...bemClassesPostControl('text')} children={role} />
      </div>
    ));
  }

  render() {
    const {
      className, itemId, data = {}, onHandleDelete, editBtn, post, checkPermission,
      complaintAdministration = false, topicId, userPostsCount
    } = this.props;

    return (
      <div {...bemClassesPostControl({ extra: className })}>
        {complaintAdministration &&
        data.countUncheckComplaints &&
        checkPermission(Perms.FORUM_CONTROL_COMPLAINT) &&
          <ComplaintsContentGetOther postId={itemId} />
        }
        <Row>
          <Col allAuto allPr={0}>
            <div {...bemClassesPostControl('leftCol')} />
          </Col>
        </Row>
        <Row {...bemClassesPostControl('main')}>
          <Col allAuto allPr={0} {...bemClassesPostControl('col', 'checkbox')}>
            <div {...bemClassesPostControl('leftCol')}>
              {this.renderCheckbox()}
            </div>
          </Col>
          <Col allPr={0} allPt={15} allPb={15} {...bemClassesPostControl('col', 'info')}>
            <div {...bemClassesPostControl('info')}>
              <div {...bemClassesPostControl('item')}>
                <ModalButton
                  buttonProps={{
                    labelSecond: data.countNotes,
                    iconType: iconTypes.note,
                    title: 'Заметки',
                    dataView: btnViews.postControl,
                  }}
                  classNameModal={bemClassesAdminPane('modal', 'notes').className}
                  size="content"
                >
                  <Header closeButton children={`Заметки для пользователя ${data.userNick} (${data.posterId})`} />
                  <Content>
                    <Comments
                      {...bemClassesAdminPane('comments')}
                      entity="users"
                      entityId={data.posterId}
                      autoHideReply={false}
                      updateEvent="updatePosts"
                      subscribe={false}
                      showCountNewComments={false}
                    />
                  </Content>
                </ModalButton>
              </div>
              <div {...bemClassesPostControl('item')}>
                <ModalButton
                  ref={el => this.modalWarning = el}
                  buttonProps={{
                    labelSecond: data.countWarnings,
                    iconType: iconTypes.complaintCircleAlmost,
                    title: 'Предупреждения',
                    dataView: btnViews.postControl,
                  }}
                  classNameModal={bemClassesAdminPane('modal', 'notifications').className}
                  size="big"
                >
                  <Header closeButton children="Предупреждения" />
                  <Content adaptiveHeight>
                    <div>
                      <NotificationsContent
                        {...bemClassesAdminPane('notifications')}
                        postId={itemId}
                        post={post}
                        closeModal={this.closeModalWarning}
                        posterId={data.posterId}
                        topicId={topicId}
                      />
                    </div>
                  </Content>
                </ModalButton>
              </div>
              <div {...bemClassesPostControl('item')}>
                <ModalButton
                  buttonProps={{
                    iconType: iconTypes.dns,
                    title: 'Юзеры на этом IP',
                    dataView: btnViews.postControl,
                  }}
                  size="medium"
                >
                  <Header closeButton>Юзеры на этом IP</Header>
                  <Content>
                    <div>Юзеры на этом IP</div>
                  </Content>
                </ModalButton>
              </div>
              <div {...bemClassesPostControl('item')}>
                <div>
                  <span {...bemClassesPostControl('text')}>Караганда</span>
                </div>
                {data.ip &&
                  <div title="IP">
                    <span {...bemClassesPostControl('text')}>IP: {data.ip}</span>
                  </div>
                }
                {data.roles && !!data.roles.length && this.renderUserRoles(data.roles)}
              </div>
              <div {...bemClassesPostControl('item')}>
                <ModalButton
                  buttonProps={{
                    iconType: iconTypes.laptop,
                    title: 'Юзеры на этом устройстве',
                    dataView: btnViews.postControl,
                  }}
                  size="medium"
                >
                  <Header closeButton>Юзеры на этом устройстве</Header>
                  <Content>
                    <div>Юзеры на этом устройстве</div>
                  </Content>
                </ModalButton>
              </div>
              <div {...bemClassesPostControl('item')}>
                <Link
                  {...bemClassesPostControl('link', 'toProfile')}
                  builder={linksBackOffice.pageAllUsersEditor}
                  builderProps={{
                    hash: `?id=${data.posterId}`,
                    title: 'Профиль'
                  }}
                  noRedirector
                  external
                  blank
                >
                  <span {...bemClassesPostControl('linkContent')}>
                    <Icon
                      {...bemClassesPostControl('icon')}
                      type={iconTypes.personCircle}
                    />
                    {data.uDateAdd &&
                      <span
                        {...bemClassesPostControl('text', 'link')}
                        children={formatDate({
                          date: get(data.uDateAdd.split(' '), '[0]'),
                          format: 'dd.mm.yyyy'
                        })}
                      />
                    }
                  </span>
                </Link>
              </div>
              <div {...bemClassesPostControl('item')}>
                <Link
                  {...bemClassesPostControl('link', 'toAllUserPosts')}
                  builder={linksForum.sectionUserPosts}
                  builderProps={{
                    user_id: data.posterId,
                    title: 'Все посты юзера'
                  }}
                  noRedirector
                  external
                  blank
                >
                  <span {...bemClassesPostControl('linkContent')}>
                    <Icon
                      {...bemClassesPostControl('icon')}
                      type={iconTypes.discussion}
                    />
                    <span
                      {...bemClassesPostControl('text')}
                      children={userPostsCount}
                    />
                  </span>
                </Link>
              </div>
              {editBtn &&
                <div {...bemClassesPostControl('item', 'edit')}>
                  {editBtn({
                    ...bemClassesPostControl('btn', 'edit'),
                    buttonProps: {
                      title: `Редактировать (PostId: ${itemId})`,
                      iconType: iconTypes.edit
                    }
                  })}
                </div>
              }
              <div {...bemClassesPostControl('item', 'del')}>
                <Button
                  {...bemClassesPostControl('btn', 'del')}
                  onClick={() => onHandleDelete({ id: itemId }, false, true)}
                  iconType={iconTypes.delete}
                  title={`Удалить (PostId: ${itemId})`}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
